import * as ServicesCriminalDefenseUploads from "$lib/data/generated/uploads/services/Criminal-Defense/uploads.js";
import * as ServicesDMVHearingUploads from "$lib/data/generated/uploads/services/DMV-Hearing/uploads.js";
import * as ServicesDUIUploads from "$lib/data/generated/uploads/services/DUI/uploads.js";
import * as ServicesDomesticViolenceUploads from "$lib/data/generated/uploads/services/Domestic Violence/uploads.js";
import * as ServicesExpungementUploads from "$lib/data/generated/uploads/services/Expungement/uploads.js";
import * as ServicesGunChargesUploads from "$lib/data/generated/uploads/services/Gun Charges/uploads.js";

export const uploads = {
  ...ServicesCriminalDefenseUploads.uploads,
  ...ServicesDMVHearingUploads.uploads,
  ...ServicesDUIUploads.uploads,
  ...ServicesDomesticViolenceUploads.uploads,
  ...ServicesExpungementUploads.uploads,
  ...ServicesGunChargesUploads.uploads
};
